import FileDownload from "js-file-download";
import toastr from "toastr";

import { API } from "../_services/api";
import { ActionKeys } from "../_actions/constants/chapterConstants";

import { downloadFileFromResponse } from "../_utils/downloadHelpers";

export const actionCreators = {
  getMemberCounts:
    (size = 10, offset = 0, sortBy = 1, sortDir = 1, year = -1) =>
    async (dispatch, getState) => {
      dispatch({ type: ActionKeys.REQUEST_MEMBER_COUNTS });
      return dispatch(
        API.chapter.getMemberCounts(size, offset, sortBy, sortDir, year)
      ).then(response => {
        dispatch({
          type: ActionKeys.RECEIVE_MEMBER_COUNTS,
          isError: response.isError,
          memberCounts: response.items,
          totalMemberCounts: response.count,
          errorMessage: response.errorMessage
        });
      });
    },
  getChapterAnalysisReports: year => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.REQUEST_CHAPTER_ANALYSIS_REPORTS });
    return dispatch(API.chapter.getChapterAnalysisReports(year)).then(
      response => {
        dispatch({
          type: ActionKeys.RECEIVE_CHAPTER_ANALYSIS_REPORTS,
          reports: response.items,
          totalReports: response.count,
          isError: response.isError,
          errorMessage: response.errorMessage
        });
      }
    );
  },
  createMemberCount: body => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.REQUEST_MEMBER_COUNTS });
    return dispatch(API.chapter.createMemberCount(body)).then(response => {
      dispatch({
        type: ActionKeys.CREATE_MEMBER_COUNT,
        isSuccess: response.isSuccess,
        isError: response.isError,
        errorMessage: response.errorMessage
      });
    });
  },
  updateMemberCount: body => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.REQUEST_MEMBER_COUNTS });
    return dispatch(API.chapter.updateMemberCount(body)).then(response => {
      dispatch({
        type: ActionKeys.UPDATE_MEMBER_COUNT,
        isSuccess: response.isSuccess,
        isError: response.isError,
        errorMessage: response.errorMessage
      });
    });
  },
  getCurrentFiscalYear: () => async (dispatch, getState) => {
    return dispatch(API.chapter.getCurrentFiscalYear()).then(response => {
      return response.item;
    });
  },
  getHelpTextByType: (typeid, subtypeid) => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.REQUEST_HELP_TEXT });
    return dispatch(API.chapter.getHelpTextByType(typeid, subtypeid)).then(
      response => {
        dispatch({
          type: ActionKeys.RECEIVE_HELP_TEXT,
          isError: response.isError,
          helpText: response.item,
          errorMessage: response.errorMessage
        });
      }
    );
  },
  getChapterFinancials: () => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.REQUEST_CHAPTER_FINANCIALS });
    return dispatch(API.chapter.getChapterFinancials()).then(response => {
      dispatch({
        type: ActionKeys.RECEIVE_CHAPTER_FINANCIALS,
        isError: response.isError,
        chapterFinancials: response.items,
        errorMessage: response.errorMessage
      });
    });
  },
  getChapterSummaryReport: id => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.REQUEST_CHAPTER_SUMMARY_REPORT });
    return dispatch(API.chapter.getChapterSummaryReport(id)).then(response => {
      downloadFileFromResponse(response, "chapter_summary.pdf");
      dispatch({
        type: ActionKeys.RECEIVE_CHAPTER_SUMMARY_REPORT,
        isError: false
      });
    });
  },
  getYearToYearReport: id => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.REQUEST_CHAPTER_SUMMARY_REPORT });
    return dispatch(API.chapter.getYearToYearReport(id)).then(response => {
      downloadFileFromResponse(response, "year_to_year.xlsx");
      dispatch({
        type: ActionKeys.RECEIVE_CHAPTER_SUMMARY_REPORT,
        isError: false
      });
    });
  },
  getComparativeReport: id => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.REQUEST_CHAPTER_SUMMARY_REPORT });
    return dispatch(API.chapter.getComparativeReport(id)).then(response => {
      downloadFileFromResponse(response, "comparative.xlsx");
      dispatch({
        type: ActionKeys.RECEIVE_CHAPTER_SUMMARY_REPORT,
        isError: false
      });
    });
  },
  getChapterFinancial: id => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.RECEIVE_CHAPTER_FINANCIAL });
    return dispatch(API.chapter.getChapterFinancial(id)).then(response => {
      dispatch({
        type: ActionKeys.RECEIVE_CHAPTER_FINANCIAL,
        isError: response.isError,
        activeChapterFinancial: response.item,
        errorMessage: response.errorMessage
      });
    });
  },
  getChapterFinancialById: id => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.RECEIVE_CHAPTER_FINANCIAL });
    return dispatch(API.chapter.getChapterFinancial(id)).then(response => {
      dispatch({
        type: ActionKeys.RECEIVE_CHAPTER_FINANCIAL,
        isSuccess: response.isSuccess,
        isError: response.isError,
        errorMessage: response.errorMessage
      });
      return response.item;
    });
  },
  getChapterFinancialByYear: (year, id) => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.REQUEST_CHAPTER_FINANCIAL_BY_YEAR });
    return dispatch(API.chapter.getChapterFinancialByYear(year, id)).then(
      response => {
        dispatch({
          type: ActionKeys.RECEIVE_CHAPTER_FINANCIAL_BY_YEAR,
          isSuccess: response.isSuccess,
          isError: response.isError,
          errorMessage: response.errorMessage
        });
        return response.items;
      }
    );
  },
  submitChapterFinancial: (id, notes) => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.SUBMIT_CHAPTER_FINANCIAL_STARTED });
    return dispatch(API.chapter.submitChapterFinancial(id, notes)).then(
      response => {
        dispatch({
          type: ActionKeys.SUBMIT_CHAPTER_FINANCIAL_FINISHED,
          isSuccess: response.isSuccess,
          isError: response.isError,
          errorMessage: response.errorMessage
        });
      }
    );
  },
  getChapterBudgets: () => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.REQUEST_CHAPTER_BUDGETS });
    return dispatch(API.chapter.getChapterBudgets()).then(response => {
      dispatch({
        type: ActionKeys.RECEIVE_CHAPTER_BUDGETS,
        isError: response.isError,
        chapterBudgets: response.items,
        errorMessage: response.errorMessage
      });
    });
  },
  getChapterBudget: id => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.REQUEST_CHAPTER_BUDGET });
    return dispatch(API.chapter.getChapterBudget(id)).then(response => {
      dispatch({
        type: ActionKeys.RECEIVE_CHAPTER_BUDGET,
        isError: response.isError,
        activeChapterBudget: response.item,
        errorMessage: response.errorMessage
      });
    });
  },
  createChapterBudget: body => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.CREATE_CHAPTER_BUDGET_STARTED });
    return dispatch(API.chapter.createChapterBudget(body)).then(response => {
      dispatch({
        type: ActionKeys.CREATE_CHAPTER_BUDGET_FINISHED,
        isSuccess: response.isSuccess,
        isError: response.isError,
        errorMessage: response.errorMessage
      });
      return response;
    });
  },
  updateChapterBudget: body => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.UPDATE_CHAPTER_BUDGET_STARTED });
    return dispatch(API.chapter.updateChapterBudget(body)).then(response => {
      dispatch({
        type: ActionKeys.UPDATE_CHAPTER_BUDGET_FINISHED,
        isSuccess: response.isSuccess,
        isError: response.isError,
        errorMessage: response.errorMessage
      });
      return response.isError ? response.errorMessage : true;
    });
  },
  updateChapterBudgetFile: (id, body) => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.UPDATE_CHAPTER_BUDGET_FILE_STARTED });
    return dispatch(API.chapter.updateChapterBudgetFile(id, body)).then(
      response => {
        dispatch({
          type: ActionKeys.UPDATE_CHAPTER_BUDGET_FILE_FINISHED,
          isSuccess: response.isSuccess,
          isError: response.isError,
          errorMessage: response.errorMessage
        });
        return response.isError ? response.errorMessage : true;
      }
    );
  },
  downloadChapterBudgetFile: filename => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.DOWNLOAD_CHAPTER_BUDGET_FILE_STARTED });
    return dispatch(API.chapter.downloadChapterBudgetFile(filename)).then(
      response => {
        if (response.status === 200) {
          toastr.success("Download started...");
          FileDownload(response.data, filename);
        }
        dispatch({
          type: ActionKeys.DOWNLOAD_CHAPTER_BUDGET_FILE_FINISHED,
          isSuccess: response.isSuccess,
          isError: response.status !== 200,
          errorMessage: response.status === 200 ? "" : "Not Found"
        });

        return response.isError ? response.errorMessage : true;
      }
    );
  },
  getChapterFinancialsDefaults: () => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.REQUEST_CHAPTER_FINANCIALS_DEFAULTS });
    return dispatch(API.chapter.getChapterFinancialsDefaults()).then(
      response => {
        dispatch({
          type: ActionKeys.RECEIVE_CHAPTER_FINANCIALS_DEFAULTS,
          chapterFinancialsDefaults: response.items,
          isError: response.isError,
          errorMessage: response.errorMessage
        });
      }
    );
  },
  createReportItem: body => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.CREATE_REPORT_ITEM_STARTED });
    return dispatch(API.chapter.createReportItem(body)).then(response => {
      dispatch({
        type: ActionKeys.CREATE_REPORT_ITEM_FINISHED,
        isSuccess: response.isSuccess,
        isError: response.isError,
        errorMessage: response.errorMessage
      });
      return response.item;
    });
  },
  updateReportItem: (id, body) => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.UPDATE_REPORT_ITEM_STARTED });
    return dispatch(API.chapter.updateReportItem(id, body)).then(response => {
      dispatch({
        type: ActionKeys.UPDATE_REPORT_ITEM_FINISHED,
        isSuccess: response.isSuccess,
        isError: response.isError,
        errorMessage: response.errorMessage
      });
    });
  },
  removeReportItem: id => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.REMOVE_REPORT_ITEM_STARTED });
    return dispatch(API.chapter.removeReportItem(id)).then(response => {
      dispatch({
        type: ActionKeys.REMOVE_REPORT_ITEM_FINISHED,
        isSuccess: response.isSuccess,
        isError: response.isError,
        errorMessage: response.errorMessage
      });
    });
  },
  updateReportItems: body => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.UPDATE_REPORT_ITEMS_STARTED });
    return dispatch(API.chapter.updateReportItems(body)).then(response => {
      dispatch({
        type: ActionKeys.UPDATE_REPORT_ITEMS_FINISHED,
        isSuccess: response.isSuccess,
        isError: response.isError,
        errorMessage: response.errorMessage
      });
    });
  },
  updateReportItemsPut: body => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.UPDATE_REPORT_ITEMS_STARTED });
    return dispatch(API.chapter.updateReportItemsPut(body)).then(response => {
      dispatch({
        type: ActionKeys.UPDATE_REPORT_ITEMS_FINISHED,
        isSuccess: response.isSuccess,
        isError: response.isError,
        errorMessage: response.errorMessage
      });
    });
  },
  initialReportItems: body => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.INITIAL_REPORT_ITEMS_STARTED });
    return dispatch(API.chapter.initialReportItems(body)).then(response => {
      dispatch({
        type: ActionKeys.INITIAL_REPORT_ITEMS_FINISHED,
        isSuccess: response.isSuccess,
        isError: response.isError,
        errorMessage: response.errorMessage
      });

      return response.message;
    });
  },
  updateReportW2: body => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.UPDATE_REPORT_W2_STARTED });
    return dispatch(API.chapter.updateReportW2(body)).then(response => {
      dispatch({
        type: ActionKeys.UPDATE_REPORT_W2_FINISHED,
        isSuccess: response.isSuccess,
        isError: response.isError,
        errorMessage: response.errorMessage
      });
    });
  },
  updateVotingCount: body => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.UPDATE_REPORT_VOTING_COUNT_STARTED });
    return dispatch(API.chapter.updateVotingCount(body)).then(response => {
      dispatch({
        type: ActionKeys.UPDATE_REPORT_VOTING_COUNT_FINISHED,
        isSuccess: response.isSuccess,
        isError: response.isError,
        errorMessage: response.errorMessage
      });
    });
  },
  createFinancialAccount: body => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.CREATE_FINANCIAL_ACCOUNT_STARTED });
    return dispatch(API.chapter.createFinancialAccount(body)).then(response => {
      dispatch({
        type: ActionKeys.CREATE_FINANCIAL_ACCOUNT_FINISHED,
        isSuccess: response.isSuccess,
        isError: response.isError,
        errorMessage: response.errorMessage
      });
    });
  },
  updateFinancialAccount: body => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.UPDATE_FINANCIAL_ACCOUNT_STARTED });
    return dispatch(API.chapter.updateFinancialAccount(body)).then(response => {
      dispatch({
        type: ActionKeys.UPDATE_FINANCIAL_ACCOUNT_FINISHED,
        isSuccess: response.isSuccess,
        isError: response.isError,
        errorMessage: response.errorMessage
      });
    });
  },
  removeFinancialAccount: body => async (dispatch, getState) => {
    dispatch({ type: ActionKeys.REMOVE_FINANCIAL_ACCOUNT_STARTED });
    return dispatch(API.chapter.removeFinancialAccount(body)).then(response => {
      dispatch({
        type: ActionKeys.REMOVE_FINANCIAL_ACCOUNT_FINISHED,
        isSuccess: response.isSuccess,
        isError: response.isError,
        errorMessage: response.errorMessage
      });
    });
  },
  resetIsFetched: () => (dispatch, getState) => {
    dispatch({ type: ActionKeys.RESET_IS_FETCHED });
  },
  resetActiveChapterBudget: () => (dispatch, getState) => {
    dispatch({ type: ActionKeys.RESET_ACTIVE_CHAPTER_BUDGET });
  }
};
